import React, { useEffect, useState ,useRef} from "react";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { useForm,Controller } from "react-hook-form";
import AuthContext from "../../context/AuthContext";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { toast } from "react-toastify";
import { useContextSelector } from "use-context-selector";
import { IoMdRefreshCircle } from "react-icons/io";
import { Form,Button } from "react-bootstrap";
import { isEmpty } from "lodash";
import { formatWithCommas, validationRules,bankType } from "../../Utils/Toast";
import iconBkash from "../../assets/images/bkash.png";
import iconRocket from "../../assets/images/rocket.png";
import iconNagad from "../../assets/images/nagad.png";
import iconEth from "../../assets/images/eth.svg";
import iconBtc from "../../assets/images/btc.svg";
import iconUpay from "../../assets/images/upay.png";
import iconTrc20 from "../../assets/images/trc20.svg";
import { t } from "i18next";
import InternalLoader from "../../component/InternalLoader";
import { useTranslation } from "react-i18next";
import ModalPhone from "./ModalPhone";
import { FaCircleInfo } from "react-icons/fa6";
const Withdraw = () => {
  const naviagte = useNavigate();
  const [show, setShow] = useState(false);
  const [bank, setBank] = useState([]);
  const [bankId, setBankId] = useState("");
  const [isLoader, setLoader] = useState(false);
    const [verifyEdit, setVerifyEdit] = useState({});
 const handleCloseVerify= () => {
    setVerifyEdit({ status: false });
  };
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
  });
  const userCoins = useContextSelector(AuthContext, (ctx) => {
    return ctx.userCoins;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
    const getProfileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.getProfileData;
  });
    const [selectedMethod, setSelectedMethod] = useState("bkash");

  const [minWithdraw, setMinWithdraw] = useState(200);
  const [maxWithdraw, setMaxWithdraw] = useState(30000);
  const numberList =
  profileData?.temporaryPhone && profileData.temporaryPhone !== 0
    ? [
        { title: profileData.temporaryPhone },
        { title: profileData.phone },
      ]
    : [{ title: profileData.phone }];

  const getBankDetail = async (body) => {
    setBankId(body);
    const { status, data } = await apiPost(apiPath.getBankDetail, {
      bank: body,
    });
    if (status == 200) {
      if (data?.success) {
        setValue("accountName", data?.results?.bankDetail?.account_name);
        setValue("bankAccount", data?.results?.bankDetail?.account_number);
      }
    }
  };

  const getBank = async () => {
    const { status, data } = await apiPost(apiPath.getBank, {
      type: "withdrawal",
    });
    if (status == 200) {
      if (data?.success) {
        setBank(data?.results?.bankList);
        if (data?.results?.bankList?.length > 0) {
          getBankDetail(data?.results?.bankList[0]?._id);
        }
      }
    }
  };
  const maskBankAccount = (value = "") => {
    if (!value) return "";
    const first4 = value.slice(0, 4);
    const masked = "*".repeat(Math.max(0, value.length - 4));
    return first4 + masked;
  };

  useEffect(() => {
    getBank();
  }, []);

  const onSubmit = async (body) => {
    setLoader(true);
    body = {
      amount: body?.amount,
      BankAccount: body?.bankAccount,
      bank: bankId,
      AccountName: selectedMethod.toUpperCase(),
      phone_number: body?.mobile,
      pin: body?.verificationCode,
      payout: true,
    };
    const { status, data } = await apiPost(apiPath.withdrawal, body);
    if (status === 200) {
      if (data.success) {
      } else {
        toast.error(data?.message);
      }
    } else {
      toast.error(data?.message);
    }
    setLoader(false);
  };
  useEffect(() => {
    if (!isEmpty(profileData) && profileData?.limitSetting.length > 0) {
      setMinWithdraw(
        profileData?.limitSetting.length > 0 &&
          profileData?.limitSetting[0]?.minWithdraw
      );
      setMaxWithdraw(
        profileData?.limitSetting.length > 0 &&
          profileData?.limitSetting[0]?.maxWithdraw
      );
    }
  }, [!isEmpty(profileData?.limitSetting)]);

  const inputRef = useRef(null);
  const { t } = useTranslation();

  const {
    register: register1,
    handleSubmit: handleSubmit1,
    control: control1,
    formState: { errors: errors1 },
    reset: reset1,
  } = useForm({});

  const [isLoader1, setLoader1] = useState(false);

  const onSubmit1 = async (body) => {
    setLoader1(true);
    const { status, data } = await apiPost(apiPath.verifyOtpNew, {
      new_phone_number:
        inputRef?.current?.state.selectedCountry?.countryCode +
        body?.mobile?.substring(
          inputRef?.current?.state.selectedCountry?.countryCode?.length,
          body?.mobile?.toString()?.length,
        ),
      phone_number: profileData?.phone
        ? profileData?.phone
        : inputRef?.current?.state.selectedCountry?.countryCode +
          body?.mobile?.substring(
            inputRef?.current?.state.selectedCountry?.countryCode?.length,
            body?.mobile?.toString()?.length,
          ),
      type: "password",
      password: body?.verificationCode,
    });
    if (status === 200) {
      if (data.success) {
        setLoader1(false);
        handleCloseVerify();
        getProfileData();
        toast.success("Otp verified successfully");
        reset();
      } else {
        setLoader1(false);
        toast.error(data?.message);
      }
    } else {
      setLoader1(false);
      toast.error(data?.message);
    }
  };
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="withdraw-container-v2">
        <Form onSubmit={handleSubmit(onSubmit)} className id="v2-vc-container">
          <div className="mc-header-wrap">
            <div
              id="mc-header"
              className="mc-navbar-blue mc-withdraw mc-default-header am-navbar am-navbar-light"
            >
              <div
                onClick={() => {
                  if (show) {
                    setShow(false);
                  } else {
                    naviagte(-1);
                  }
                }}
                className="am-navbar-left"
                role="button"
              >
                <span className="am-navbar-left-content">
                  <span className="return_icon">
                    <svg
                      style={{ color: "black" }}
                      className="am-icon am-icon-left am-icon-lg"
                    >
                      <use xlinkHref="#left" />
                    </svg>
                  </span>
                </span>
              </div>
              <div className="am-navbar-title">Withdrawal</div>
              <div className="am-navbar-right">
                <div>
                  <span
                    onClick={() => naviagte("/member/withdrawRecord")}
                    className="report-icon"
                  >
                    <svg className="am-icon am-icon-withdraw_record_c986adfb am-icon-md am-navbar-title">
                      <use xlinkHref="#withdraw_record_c986adfb" />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
            <div className="am-whitespace am-whitespace-sm mc-whitespace" />
          </div>{" "}
          <div className="vc-scroll-container ">
            <div className="vc-v2-container ">
              <div className=" ranndom-container">
                {" "}
                <div style={{ marginTop: "15px", marginBottom: "15px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      fontWeight: "600",
                      fontSize: "16px",
                    }}
                  >
                    <span>{t("Withdrawal Amount")} </span>
                      <span>
                        BDT{" "}
                        {Math.max(
                          Math.trunc(
                            ((Number(userCoins?.balance) || 0) -
                              (Number(profileData?.availableTurnoverFinal) || 0)) * 100
                          ) / 100,
                          0
                        )}
                      </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      fontWeight: "600",
                      fontSize: "16px",
                    }}
                  >
                    <span>{t("Holding Amount")} </span>
                    <span>
                      BDT{" "}
                      {Number(profileData?.availableTurnoverFinal).toFixed(2) ||
                        0}{" "}
                    </span>
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "end",alignItems:"center"
                  }}
                > <FaCircleInfo onClick={() => naviagte('/terms')} color="blue" style={{marginRight:"5px"}}/>
                  <button
                    onClick={() => naviagte("/member/turnover")}
                    type="button"
                    class="btn-success am-button"
                    style={{
                      width: "30%",
                      padding: "5px",
                      height: "auto",
                      lineHeight: "normal",
                      fontSize: "14px",
                      marginBottom: "5px",
                      backgroundImage: "#108ee9",
                      backgroundColor: "#108ee9",
                    }}
                  >
                    <span>Turnover</span>
                  </button>
                </div>
                <div className="vc-v2-title">Withdraw Method</div>
                <div className="min-list vc-v2-method  show-more-container">
                  <ul>
                    {bankType?.length > 0 &&
                      bankType?.map((res) => {
                        return (
                          <li
                           
                             checked={selectedMethod === res.bank_name}
                            onClick={() => {
                              setSelectedMethod(res.bank_name);
                              getBankDetail(res?._id);
                              setValue("bank", res?._id);
                            }}
                            className={`change-item-animate NAGAD ${
                              selectedMethod === res.bank_name ? "ck" : ""
                            }`}
                          >
                            {selectedMethod === res.bank_name && (
                              <svg className="am-icon am-icon-checked_0a488f7d am-icon-md deposit-list-ck">
                                <use xlinkHref="#checked_0a488f7d" />
                              </svg>
                            )}
                            <div className="deposit-img-new">
                              <img
                                src={
                                  res?.bank_name.toLowerCase().includes("bkash")
                                    ? iconBkash
                                    : res?.bank_name
                                        .toLowerCase()
                                        .includes("nagad")
                                    ? iconNagad
                                    : res?.bank_name
                                        .toLowerCase()
                                        .includes("rocket")
                                    ? iconRocket
                                    : res?.bank_name
                                        .toLowerCase()
                                        .includes("eth")
                                    ? iconEth
                                    : res?.bank_name
                                        .toLowerCase()
                                        .includes("btc")
                                    ? iconBtc
                                    : res?.bank_name
                                        .toLowerCase()
                                        .includes("upay")
                                    ? iconUpay
                                    : iconTrc20
                                }
                                alt
                                style={{ display: "block" }}
                              />
                            </div>
                            <div className="desc-content">
                              <div className="desc-info">
                                <div className="vcn-list-text">
                                  <p>{res?.bank_name}</p>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </div>
                <button
                  onClick={() =>
                    setVerifyEdit({
                      ...verifyEdit,
                      status: true,
                      phoneStatus: "add",
                      item: profileData?.phone,
                    })
                  }
                  type="button"
                  class="btn-success am-button"
                  style={{
                    width: "30%",
                    padding: "5px",
                    height: "auto",
                    lineHeight: "normal",
                    fontSize: "14px",
                    marginBottom: "5px",
                    backgroundImage: "#108ee9",
                    backgroundColor: "#108ee9",
                  }}
                >
                  <span> {"Add Phone"}</span>
                </button>
              </div>
              <div className="vc-v2-space-content vc-v2-space-content" />
              <div className>
                {!isEmpty(bankId) && (
                  <>
                    <div className="ranndom-container">
                      <div className="vc-v2-title pay-name ">Account Name</div>
                      <div className="vc-v2-input no-border">
                        <div className="inputCon">
                          <input
                            type="text"
                            inputMode="text"
                            style={{ width: "100%" }}
                            className="inputBase"
                            placeholder="Bank Account Name"
                            {...register("accountName")}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="ranndom-container">
                      <div className="vc-v2-title pay-name ">
                        {t("Bank_Account")}
                      </div>
                      <div className="vc-v2-input no-border">
                        <div className="inputCon">
                          <input
                            type="text"
                            inputMode="text"
                            className="inputBase"
                            placeholder="Bank account number"
                            disabled
                            value={maskBankAccount(watch("bankAccount"))}
                            {...register("bankAccount")}
                            style={{ paddingLeft: "10px", width: "100%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className="ranndom-container">
                  <div className="vc-v2-title pay-name ">Mobile Number</div>
                  <div className="vc-v2-input no-border">
                    <div className="inputCon">
                      <select
                        {...register("mobile", {
                          required: "Please select mobile",
                          onChange: (e) => {
                            setValue("bankAccount", e.target.value);
                          },
                        })}
                        className="inputBase"
                      >
                        <option value={""}>Select</option>
                        {numberList?.map((res) => {
                          return (
                            <option value={res?.title}>{res?.title}</option>
                          );
                        })}
                      </select>
                    </div>{" "}
                    {errors?.mobile?.message && (
                      <div className="vc-tips" style={{ paddingTop: "5px" }}>
                        <div
                          className="wysiwyg"
                          style={{ fontSize: "12px", paddingBottom: "0" }}
                        >
                          * {errors?.mobile?.message}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  id="payAmount"
                  style={{ paddingBottom: "0" }}
                  className="ranndom-container vc-v2-amount"
                >
                  <div className="vc-v2-title  pay-amount">Amounts</div>
                  <div className="vc-v2-input">
                    <div className="deposit-amount-con">
                      <div className="fixed-money">
                        {AmountArray?.map((res) => {
                          return (
                            <div
                              onClick={() => setValue("amount", res?.amount)}
                              className={`fixed-money-item number-mc ${
                                watch("amount") == res?.amount
                                  ? "money-active"
                                  : ""
                              }`}
                            >
                              {res?.amount}
                            </div>
                          );
                        })}
                      </div>
                      <div>
                        <div className="inputCon">
                          <i>৳</i>
                          <input
                            type="text"
                            inputMode="decimal"
                            placeholder={`${formatWithCommas(
                              minWithdraw
                            )} - ${formatWithCommas(maxWithdraw)}`}
                            className="inputBase"
                            {...register("amount", {
                              required: {
                                value: true,
                                message: "Please enter amount",
                              },
                              validate: (value) => {
                                if (value > 0) {
                                  if (Number(value) > Number(maxWithdraw)) {
                                    return (
                                      "Amount should not be greater than " +
                                      maxWithdraw
                                    );
                                  } else if (value < Number(minWithdraw)) {
                                    return (
                                      "Minimum Amount Should be greater than " +
                                      minWithdraw
                                    );
                                  }
                                } else {
                                  return t("Amount_0");
                                }
                              },
                            })}
                          />
                        </div>

                        {errors?.amount?.message && (
                          <div
                            className="vc-tips"
                            style={{ paddingTop: "5px" }}
                          >
                            <div
                              className="wysiwyg"
                              style={{ fontSize: "12px", paddingBottom: "0" }}
                            >
                              * {errors?.amount?.message}
                            </div>
                          </div>
                        )}
                        <div className="vc-tips" style={{ paddingTop: "5px" }}>
                          <div
                            className="wysiwyg"
                            style={{ fontSize: "12px", paddingBottom: "0" }}
                          >
                            * Minimum Amount : ৳{formatWithCommas(minWithdraw)}
                            ，Maximum Amount : ৳ {formatWithCommas(maxWithdraw)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>{" "}
                <div className="ranndom-container">
                  <div className="vc-v2-title pay-name ">Password</div>
                  <div className="vc-v2-input no-border">
                    <div className="inputCon">
                      <input
                        type="text"
                        inputMode="text"
                        className="inputBase"
                        placeholder="Password"
                        {...register("verificationCode", {
                          required: "Please enter password",
                        })}
                        style={{ paddingLeft: "10px", width: "100%" }}
                      />
                    </div>{" "}
                    {errors?.verificationCode?.message && (
                      <div className="vc-tips" style={{ paddingTop: "5px" }}>
                        <div
                          className="wysiwyg"
                          style={{ fontSize: "12px", paddingBottom: "0" }}
                        >
                          * {errors?.verificationCode?.message}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
          <div className=" vc-v2-submit">
            <button
              disabled={isLoader}
              type="submit"
              style={{
                background: "transparent",
                border: "none",
                color: "white",
              }}
            >
              Withdraw
            </button>
          </div>
        </Form>
      </div>
       {verifyEdit?.status && (
        <ModalPhone
          setVerifyEdit={setVerifyEdit}
          onSubmit1={onSubmit1}
          errors1={errors1}
          verifyEdit={verifyEdit}
          handleSubmit1={handleSubmit1}
          control1={control1}
          inputRef={inputRef}
          register1={register1}
          isLoader1={isLoader1}
        />
      )}
      {isLoader && <InternalLoader />}
    </div>
  );
};

export default Withdraw;
export const AmountArray = [
  { id: 1, amount: 200 },
  { id: 2, amount: 500 },
  { id: 3, amount: 1000 },
  { id: 4, amount: 5000 },
  { id: 5, amount: 15000 },
  { id: 6, amount: 20000 },
  { id: 7, amount: 25000 },
];